export default {
    // 页面高度
    SET_ASIDE_HEIGHT: 'SET_ASIDE_HEIGHT',
    // 页面宽度
    SET_ASIDE_WIDTH: 'SET_ASIDE_WIDTH',
    // 登录信息
    SET_LOGIN_INFO: 'SET_LOGIN_INFO',
}